import { IDocuments } from './IDocuments';
import { documentProperties } from './mapperConfig';
import { UtilityService } from '../../../infrastructure/services/utils';

/**
 * provide transformation functionality for document data using mapper configuration
 * @param   {Object} documentItem transformed object
 */
export class DocumentMapper {
  documentItem: IDocuments = {};

  constructor(documentProperty: [] = []) {
    this.documentItem = UtilityService.getMappedProperties(
      documentProperty,
      documentProperties,
      this.documentItem
    );
  }
}
